import { Grid, Paper } from '@mui/material'
import { styled } from '@mui/material/styles'

interface GridTypes {
    children?: any
    columns?: number | object
    columnSpacing?: any
    container?: boolean
    item?: boolean
    direction?:
        | 'column-reverse'
        | 'column'
        | 'row-reverse'
        | 'row'
        | Array<'column-reverse' | 'column' | 'row-reverse' | 'row'>
        | object
    offset?: number
    rowSpacing?: Array<number | string> | number | object | string
    size?: number | object | 'grow'
    spacing?: Array<number | string> | number | object | string
    wrap?: 'nowrap' | 'wrap-reverse' | 'wrap'
    ref?: any
    sx?: object
    style?: object
    hidden?: boolean
    role?: string
    xs?: number
    md?: number
    lg?: number
    alignItems?: string
    id?: any
    key?: any
    onClick?: () => void
    className?: string
}

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: (theme.vars ?? theme).palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}))

const UniversalGrid = ({
    children,
    columns = 12,
    columnSpacing = null,
    container = false,
    item = false,
    direction = 'row',
    offset,
    rowSpacing,
    size = { xs: 12, md: 12, lg: 12 },
    xs,
    md,
    lg,
    spacing = 0,
    wrap = 'wrap',
    ref,
    sx = {},
    style = {},
    hidden,
    role,
    alignItems,
    id,
    key,
    onClick = () => {},
    className,
}: GridTypes) => {
    if (container) {
        return (
            <Grid
                container
                columns={columns}
                columnSpacing={columnSpacing}
                direction={direction}
                rowSpacing={rowSpacing}
                wrap={wrap}
                role={role}
                hidden={hidden}
                sx={sx}
                style={style}
                ref={ref}
                spacing={spacing}
                alignItems={alignItems}
                id={id}
                onClick={onClick}
                className={className}
                offset={offset}
                key={key}
            >
                {children}
            </Grid>
        )
    } else if (item) {
        return (
            <Grid
                size={size && !container ? { xs, md, lg } : size}
                sx={sx}
                style={style}
                hidden={hidden}
                ref={ref}
                role={role}
                id={id}
                className={className}
                onClick={onClick}
                offset={offset}
                key={key}
            >
                {children}
            </Grid>
        )
    } else {
        return (
            <Grid
                size={size && !container ? { xs, md, lg } : size}
                sx={sx}
                style={style}
                hidden={hidden}
                ref={ref}
                role={role}
                id={id}
                className={className}
                onClick={onClick}
                offset={offset}
                key={key}
            >
                {children}
            </Grid>
        )
    }
}

export default UniversalGrid
